<template>
<div v-if="showTotalItems">
    <v-sheet  color="bgtopology" class="defaultCard" >
        <v-row class="no-gutters" justify="center">
            <v-col cols="12" md="6" lg="4" v-for="(item,i) in finalItemsKPI" :key="i">
                <span class="titleDashboard">{{ t(`labels.${item.valor}`) }}</span>
                <v-row class="mt-4">
                    <v-col cols="12">
                        <SingleCard class="cardSingleKPI" @click="goToTopology(item.valor)" :heigth="height" :bottomText="t('labels.ok_pl')" :icon="'mdi-check'" :color-icon="COLOR.green" :middleText="item.count.ok.toString()"/>
                    </v-col>
                    <v-col cols="12">
                        <SingleCard class="cardSingleKPI" @click="goToTopology(item.valor)" :heigth="height" :bottomText="t('labels.alert_pl')" :icon="'mdi-lightbulb-on-outline'" :color-icon="COLOR.yellow" :middleText="item.count.alert.toString()"/>
                    </v-col>
                    <v-col cols="12">
                        <SingleCard class="cardSingleKPI" @click="goToTopology(item.valor)" :heigth="height" :bottomText="t('labels.alarm_pl')" :icon="'mdi-exclamation-thick'" :color-icon="COLOR.red" :middleText="item.count.alarm.toString()"/>
                    </v-col>
                    <v-col cols="12">
                        <SingleCard class="cardSingleKPI" @click="goToTopology(item.valor)" :heigth="height" :bottomText="t('labels.down_pl')" :icon="'mdi-close'" :color-icon="COLOR.greyfake" :middleText="item.count.down.toString()"/>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-sheet color="transparent" :width="smAndDown ? 500 : 395" height="460">
                        <v-col class="pa-0" style="height: 460px; align-content: center;">                    
                            <GaugeComponent
                            :recharge="false"
                            :array-items="item.total"
                            :valorCard ="item.valor"
                            />
                        </v-col>
                    </v-sheet>
                </v-row>
                <v-row justify="center">
                    <v-sheet color="transparent" :width=" width" :class="mdAndDown ? 'pb-3' : 'pr-2'">
                        <div>
                            {{ t('labels.msn') }}
                        </div>
                        <TimeLineAlerts
                        v-if="item.alarm.length > 0"
                        :array-items="item.alarm"
                        :width="400"
                        :height="height"
                        />
                        <p class="mt-8" v-else>
                            <span class="textDashboard" > {{ t('noAlertsAlarm') }} </span>  
                        </p>
                    </v-sheet>
                </v-row>
            </v-col>
        </v-row>
    </v-sheet>
</div>

<v-sheet v-else color="bgtopology" class="defaultCard text-center">
    <Prog_circular />
</v-sheet>

</template>

<script setup lang="ts">
import {  Ref, ref, computed, onMounted, } from 'vue';
import type { PropType } from 'vue';
import router from '@/router';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { mdAndDown, smAndDown } = useDisplay();

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS, STRING_GENERAL } from '@/constants/labels';
import { COLOR } from '@/constants/colors';

/********************************
 ********** COMPONENTS **********
 *******************************/
import GaugeComponent from '@/components/SmartLink/dashboard/GaugeComponent.vue';
import TimeLineAlerts from '@/components/SmartLink/dashboard/TimeLineAlerts.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import SingleCard from '@/components/SmartLink/topology/SingleCard.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { KPI_COMP, OBJ_ALARM_TYPE, OBJ_TYPE_STATUS } from '@/interfaces/SmartLink/Equipos';

// KPI-Component.vue (<script setup lang="ts">)
const props = defineProps({
    countEquipStatus  : { type: Object as PropType<OBJ_TYPE_STATUS>, required: true },
    alarmData         : { type: Object as PropType<OBJ_ALARM_TYPE>, default: () => ({ distri: [], acceso: [], client: [] }) },
    operabilityData   : { type: Object, default: () => ({
        distribución: { now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 },
        acceso: { now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 },
        cliente: { now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 }
    }) }
});

// Construcción reactiva usando las alertas normales (props.alarmData)
const finalItemsKPI = computed<KPI_COMP>(() => ({
    distri: { valor: STRING_GENERAL.distri, alarm: props.alarmData.distri, total: props.operabilityData.distribución, count: props.countEquipStatus.distri, showError: false },
    acceso: { valor: STRING_GENERAL.access, alarm: props.alarmData.acceso, total: props.operabilityData.acceso, count: props.countEquipStatus.acceso, showError: false },
    client: { valor: STRING_GENERAL.client, alarm: props.alarmData.client, total: props.operabilityData.cliente, count: props.countEquipStatus.client, showError: false },
}));

const width     = ref('425');
const height    = ref(160);

/**
 * Muestra el componente entero una vez se haya cargado toda la información
 */
const showTotalItems = computed(() => 
  Boolean(props.operabilityData?.cliente) || props.alarmData.client.length > 0
);



/**
 * Cuando se le da click a alguno de los números, redirecciona a la vista
 * de topología de red, desplazando hasta el subtipo especificado
 * @param viewPage Subtipo de los equipos
 */
const goToTopology = (viewPage:string) => {
    router.push(`/smartlink/topology#${viewPage}`)
}


</script>